import { render, staticRenderFns } from "./FieldSelectTranslator.vue?vue&type=template&id=2281a7ea&"
import script from "./FieldSelectTranslator.vue?vue&type=script&lang=js&"
export * from "./FieldSelectTranslator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports